export function encode(params) {
  return JSON.stringify(params);
}
